import { render, staticRenderFns } from "./CardFacility.vue?vue&type=template&id=3904d1f6&scoped=true"
import script from "./CardFacility.vue?vue&type=script&lang=js"
export * from "./CardFacility.vue?vue&type=script&lang=js"
import style1 from "./CardFacility.vue?vue&type=style&index=1&id=3904d1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904d1f6",
  null
  
)

export default component.exports